export const featureGroups = [
  {
    icon: "chart",
    title: "Charts that give you the full picture",
    text: "Explore candles, multiple timeframes and side-by-side layouts. Compare symbols, zoom into history and keep your analysis in view.",
    tags: ["Multiple chart styles", "Custom timeframes", "Symbol comparison"],
  },
  {
    icon: "layers",
    title: "Your edge, visualized with VT",
    text: "Bring Visual Trading signals, targets, confidence and timeframe trends into one connected indicator group.",
    tags: ["Visual candles", "MTF targets", "Confidence & trends"],
  },
  {
    icon: "drawing",
    title: "Make every idea visible",
    text: "Mark the levels that matter with organized drawing tools, from trend lines and channels to Fibonacci, Gann and chart patterns.",
    tags: ["Drawing categories", "Object tree", "Undo & redo"],
  },
  {
    icon: "indicator",
    title: "Go deeper than price",
    text: "Build your analysis with moving averages, momentum, volatility and volume studies. Save your favorite indicator combinations.",
    tags: ["RSI & MACD", "VWAP & volume", "Indicator groups"],
  },
  {
    icon: "replay",
    title: "Practice. Review. Refine.",
    text: "Step back through loaded market history, test an SMA crossover with costs, and explore ideas with paper trading.",
    tags: ["Bar replay", "Strategy backtest", "Paper trading"],
  },
  {
    icon: "orderflow",
    title: "See what moves the market",
    text: "Explore Binance order-book snapshots, recent trade footprints and time-and-sales alongside your chart analysis.",
    tags: ["Binance order flow", "Buy/sell delta", "Earlier candle history"],
  },
  {
    icon: "ai",
    title: "A second perspective, on demand",
    text: "Ask the AI assistant about your analysis and turn indicator ideas into custom scripts with the indicator builder.",
    tags: ["AI assistant", "Indicator builder", "Custom scripts"],
  },
  {
    icon: "cloud",
    title: "Make the workspace yours",
    text: "Save chart settings, drawings and indicators to your account. Switch layouts, set browser price alerts and export your analysis.",
    tags: ["Account workspaces", "Price alerts", "CSV & snapshots"],
  },
];
export const pricingFeatures = [
  "Visual Trading indicator suite",
  "Technical indicators & drawing tools",
  "Multiple layouts & symbol comparison",
  "Bar replay & paper trading",
  "SMA crossover backtesting",
  "AI assistant & custom indicator builder",
  "Binance order flow & candle history",
  "Account workspaces, CSV & snapshots",
];
export const pricingFaqs = [
  {
    q: "Can I try TradingCandle before paying?",
    a: "Yes. Eligible accounts can activate a seven-day Pro trial with 50 AI credits. No card is required to start the trial.",
  },
  {
    q: "What is the difference between monthly and yearly?",
    a: "Both include the same Pro charting tools. Monthly gives you 30 days of access; yearly gives you 365 days at a lower total price than twelve monthly purchases.",
  },
  {
    q: "Do I need a broker account?",
    a: "You can analyze Binance crypto markets without connecting a broker. Indian market data and trading connections depend on your selected provider and its credentials or subscription.",
  },
  {
    q: "Does Pro include exchange data subscriptions?",
    a: "Third-party broker and exchange subscriptions are separate. Order-flow tools currently use Binance; provider capabilities and historical coverage vary.",
  },
  {
    q: "Will I be charged automatically?",
    a: "Checkout purchases a fixed access period. There is no automatic subscription renewal in this checkout flow. You can purchase another period when you need it.",
  },
  {
    q: "Where can I manage my subscription?",
    a: "Your dashboard shows your subscription status and expiry, payment history and connected brokers.",
  },
];
